import {combineReducers} from '@reduxjs/toolkit';
import navbar from './navbar.slice'

const authReducers = combineReducers({
  navbar
});

export default authReducers;